import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    OutlinedInput,
    Typography,
    Box,
    CircularProgress
} from '@mui/material';
import TranslateIcon from '@mui/icons-material/Translate';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const TranslateModal = ({ open, onClose, onTranslate, locales = [], loading = false }) => {
    const [selectedLocales, setSelectedLocales] = useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedLocales(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleTranslate = () => {
        onTranslate(selectedLocales);
        // Note: We don't clear selectedLocales here in case of error/retry, 
        // but the parent might close the modal which resets state if not controlled.
        // If controlled, parent handles closing.
    };

    return (
        <Dialog open={open} onClose={loading ? null : onClose} fullWidth maxWidth="sm">
            <DialogTitle display="flex" alignItems="center" gap={1}>
                <TranslateIcon />
                Translate Entry
            </DialogTitle>
            <DialogContent>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                    Select the target languages you want to translate this entry into.
                    Existing content in these languages will be overwritten.
                </Typography>

                <FormControl sx={{ width: '100%' }}>
                    <InputLabel id="multiple-checkbox-label">Taget Languages</InputLabel>
                    <Select
                        labelId="multiple-checkbox-label"
                        id="multiple-checkbox"
                        multiple
                        value={selectedLocales}
                        onChange={handleChange}
                        input={<OutlinedInput label="Taget Languages" />}
                        renderValue={(selected) => selected.join(', ')}
                        MenuProps={MenuProps}
                        disabled={loading}
                    >
                        {locales.map((locale) => (
                            <MenuItem key={locale} value={locale}>
                                <Checkbox checked={selectedLocales.indexOf(locale) > -1} />
                                <ListItemText primary={locale} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading} color="inherit">
                    Cancel
                </Button>
                <Button
                    onClick={handleTranslate}
                    variant="contained"
                    color="primary"
                    disabled={selectedLocales.length === 0 || loading}
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <TranslateIcon />}
                >
                    {loading ? 'Translating...' : 'Translate'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TranslateModal;
